export interface LeadPopupParams {
  isAuthenticated: boolean;
  registrationOpen: boolean;
  /** L'utente ha scrollato vicino al fondo della pagina (trigger d'abbandono). */
  reachedBottom: boolean;
  todayISO: string;
  lastDismissISO: string | null;
}

/**
 * Mostra il popup lead (abbandono) solo a visitatore non loggato, registrazioni
 * aperte, quando arriva vicino al fondo pagina, una volta al giorno (reshow se la
 * data di chiusura non è oggi).
 */
export function shouldShowLeadPopup(p: LeadPopupParams): boolean {
  if (p.isAuthenticated || !p.registrationOpen || !p.reachedBottom) return false;
  if (!p.lastDismissISO) return true;
  return p.lastDismissISO !== p.todayISO;
}
